<template>
  <button
    class="duration-220 relative flex min-h-[40px] w-full items-center justify-between whitespace-nowrap rounded-full border border-ng70 py-2 px-5 text-left text-ng400 shadow-md transition ease-out hover:border-ng50 hover:text-ng600 focus:outline-none focus-visible:ring focus-visible:ring-ng70 focus-visible:ring-opacity-75"
    @click="
      filterStore.toggleFiltersSideDrawer(true);
      filterStore.clearActiveFilterTab();
    "
  >
    <div class="flex items-center justify-between text-sm [line-height:1]">
      <span class="uppercase">{{ $t("filters") }}</span>
    </div>
    <div
      class="text-sm font-semibold leading-[1]"
      v-if="filterStore.getNumberOfActiveCategories || router.currentRoute.value.query.brand"
    >
      ({{ filterStore.getNumberOfActiveCategories + (router.currentRoute.value.query.brand ? 1 : 0) }})
    </div>
    <Icon v-else name="ep:plus" size="20" />
  </button>
</template>
<script setup lang="ts">
import { useFilters } from "~~/stores/filters";
const router = useRouter();
const filterStore = useFilters();
const { t: $t } = useI18n();
</script>
<style lang="scss" scoped></style>
